import { jwtDecode } from 'jwt-decode';

class TokenService {
  static getAccessToken() {
    return localStorage.getItem('token');
  }

  static getRefreshToken() {
    return localStorage.getItem('refreshToken');
  }

  static getTokenTimestamp() {
    const timestamp = localStorage.getItem('tokenTimestamp');
    return timestamp ? parseInt(timestamp, 10) : null;
  }

  static setTokens(accessToken, refreshToken) {
    localStorage.setItem('token', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('tokenTimestamp', Date.now().toString());
  }

  static clearTokens() {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('tokenTimestamp');
  }

  static isTokenExpired(token) {
    if (!token) return true;
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      return decoded.exp < currentTime;
    } catch {
      return true;
    }
  }

  static shouldRefresh(token) {
    if (!token) return false;
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      // Refresh if token will expire in less than 5 minutes
      return decoded.exp - currentTime < 300;
    } catch {
      return false;
    }
  }
}

export default TokenService; 